import React from 'react'

import Levels from '../../levels/containers/Levels'
/**
 * Used for GCI 
 * 
['Level 1','Level 2','Level 3','Level 4','Level 5']
          [ 'First Manager Level',
            'Middle Manager Level',
            'Senior Manager Level']
*/
const levels = ['First Manager Level','Middle Manager Level','Senior Manager Level']
export default ({activity}) => (
    <div className="ms-Grid">
    {activity.cpsArray ? activity.cpsArray.map( (item,i) => 
      <div key={i} className="ms-Grid-row">
        <div className="ms-Grid-col ms-lg3 ms-font-xl">{item.name}</div>
          <div className="ms-Grid-col ms-lg9">{item.description}</div>
        { item.id !== 'cLbnxJXmGcUzvYlZcMWi' ? <div></div> : <div className="ms-Grid-col ms-lg2">&nbsp;</div> }
        { levels.map( (level,i) => <div key={i} className="ms-Grid-col ms-lg3">{level}</div>) }
        <div className="ms-Grid-col ms-lg12">
          <Levels items={item.levels}/>
        </div>
      </div> 
      ) :  <span>Loading</span>}
    </div>
)


// WEBPACK FOOTER //
// ./src/activities/components/CompetenciesArray.js